module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-d6b1e58d.png";